export default {
  pre_1_day_thai_buddhist_holy_day: 'Pre-พระ',
  thai_buddhist_holy_day: 'พระไทย',
  chinese_buddhist_holy_day: 'พระจีน',
  pre_1_auspicious_day_hour: 'Pre-ธงไชยเวลา',
  pre_1_auspicious_day_color: 'Pre-ธงไชยสี',
  pre_1_auspicious_day_activity: 'Pre-ธงไชยกิจกรรม',
  auspicious_day_hour: 'ธงไชยเวลา',
  auspicious_day_color: 'ธงไชยสี',
  auspicious_day_activity: 'ธงไชยกิจกรรม',
  inauspicious_day: 'กาลกิณี',
  incompatible_day: 'วันชง',
  compatible_day_hour: 'วันฮะเวลา',
  compatible_day_color: 'วันฮะสี',
  compatible_day_activity: 'วันฮะกิจกรรม',
  thai_holiday: 'นักขัตฤกษ์',
  thai_buddhist_holiday: 'ศาสนา',
  chinese_god_worship_day: 'ไหว้เจ้า',
  birthday_10_years: 'วันเกิด10',
  birthday_20_years: 'วันเกิด20',
  birthday_30_years: 'วันเกิด30',
  birthday_40_years: 'วันเกิด40',
  birthday_50_years: 'วันเกิด50',
  birthday_after_50_years: 'วันเกิด50+',
  monthly_direction: 'ทิศรายเดือน',
  post_10_day_monthly_direction: 'Warn-ทิศรายเดือน',
  pre_5_day_lucky_number: 'Pre5-เลข',
  pre_3_day_lucky_number: 'Pre3-เลข',
  lucky_number: 'เลขทิศ',
  monthly_prophecy: 'ดวงรายเดือน',
  post_10_day_monthly_prophecy: 'Warn-ดวงรายเดือน',
  auspicious_select_date: 'เลือกฤกษ์',
  auspicious_completed: 'ฤกษ์สำเร็จ',
  pre_1_day_compatibility_calendar_good_day: 'วันดีสมพงศ์',
  pre_1_day_compatibility_calendar_expiration: 'หมดอายุปฏิทิน',
  pre_1_day_subscription_expiration: 'หมดอายุ',
  start_of_month_encourage_basic_to_subscribe: 'subscription',
  post_1_day_encourage_trial_to_subscribe: 'convert1-trial',
  post_2_day_encourage_new_user_to_trial: 'convert2-trial',
  post_5_day_encourage_new_user_to_trial: 'convert5-trial',
  post_7_day_encourage_new_user_to_trial: 'convert7-trial',
  pre_1_day_lucky_color_expiration: 'Exสีมงคล',
  one_time_purchase_lucky_number: 'เลขมงคล',
  one_time_purchase_lucky_color: 'สีมงคล',
  one_time_purchase_compatibility: 'สมพงศ์',
  pre_7_day_credits_expiration: 'Pre7DayCreditExpiration',
  pre_3_day_credits_expiration: 'Pre3DayCreditExpiration',
  post_3_day_no_active: 'Noactive3',
  post_7_day_no_active: 'Noactive7',
  post_14_day_no_active: 'Noactive14',
  pre_3_day_trial_expiration: 'Pre3DayTrialExpiration',
  daily_horoscope: 'Daily Horoscope',
}
